import { SVG } from "@svgdotjs/svg.js";
import * as Doms from "oc-ui/Doms";

export class MySvg {
  svg: any;
  dashedCircle: any;
  dashedCircleAlt: any;

  constructor(parentElement: HTMLElement) {
    this.svg = SVG();
    const rect = parentElement.getBoundingClientRect();
    this.svg.viewbox(0, 0, rect.width, rect.height);
    this.svg.addClass("fullsize no-pointer-events-tree");
    parentElement.append(this.svg.node);
  }

  push() {
    let group = this.svg.group();
    group.parent = this.svg;
    this.svg = group;
    return this;
  }

  pop() {
    this.svg = this.svg.parent;
    return this;
  }

  circle(options: { center: { x: number; y: number }; radius: number }) {
    let group = this.svg.group();
    group.transform({
      translateX: options.center.x,
      translateY: options.center.y,
    });
    const g = group.group();
    g.parent = group;
    const c = g.circle();
    c.parent = g;
    return c.radius(options.radius);
  }

  addClass(clazz: string) {
    this.svg.addClass(clazz);
    return this;
  }

  removeClass(clazz: string) {
    this.svg.removeClass(clazz);
    return this;
  }

  line(p1: { x: number; y: number }, p2: { x: number; y: number }) {
    return this.svg.line(p1.x, p1.y, p2.x, p2.y);
  }

  remove() {
    Doms.removeElement(this.svg.node);
  }
}
